import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function CTA() {
  return (
    <div className="bg-gradient-to-br from-[#00D95F] to-[#00C054] py-12 sm:py-16 lg:py-20 px-4" data-testid="cta-section">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 sm:mb-6">
          Ready to connect with WhatsApp Business API?
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto">
          Join 1000+ businesses already using GiriChat to grow their customer base and increase revenue.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <Button size="lg" className="bg-white text-[#00D95F] hover:bg-gray-100 px-6 sm:px-8 w-full sm:w-auto" asChild>
            <Link to="/signup">
              Start Free Trial
              <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
            </Link>
          </Button>
          <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white/10 px-6 sm:px-8 w-full sm:w-auto" asChild>
            <Link to="/contact">Schedule Demo</Link>
          </Button>
        </div>

        <div className="mt-6 sm:mt-8 flex flex-wrap justify-center gap-4 sm:gap-8 text-white/80 text-xs sm:text-sm">
          <div className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path d="M10 0L12.245 6.91L19.51 6.91L13.633 11.18L15.878 18.09L10 13.82L4.122 18.09L6.367 11.18L0.49 6.91L7.755 6.91L10 0Z" fill="currentColor"/>
            </svg>
            <span>No credit card required</span>
          </div>
          <div className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path d="M10 0L12.245 6.91L19.51 6.91L13.633 11.18L15.878 18.09L10 13.82L4.122 18.09L6.367 11.18L0.49 6.91L7.755 6.91L10 0Z" fill="currentColor"/>
            </svg>
            <span>14-day free trial</span>
          </div>
          <div className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
              <path d="M10 0L12.245 6.91L19.51 6.91L13.633 11.18L15.878 18.09L10 13.82L4.122 18.09L6.367 11.18L0.49 6.91L7.755 6.91L10 0Z" fill="currentColor"/>
            </svg>
            <span>Cancel anytime</span>
          </div>
        </div>
      </div>
    </div>
  );
}
